import { filterState } from './AddressesHelper';
import { market } from '../../constants';

const checkFirsNumberIsNine = (phone) => /^9\d+$/.test(phone);

export const getAddressTextCl = (address, regions) => {
  const stateFiltered = filterState(address, regions);
  if (!stateFiltered.length) return '';
  const cityFiltered = stateFiltered[0].children.filter(function (city) {
    return city.id.toString() === address.city;
  });
  if (!cityFiltered.length) return stateFiltered[0].name;
  return `${stateFiltered[0].name}, ${cityFiltered[0].name}`;
};

export const definePhoneNumberToAddressCl = (state) => {
  const isMobile = checkFirsNumberIsNine(state['phone'].value.toString());
  return {
    mobilePhone1: isMobile ? state['phone'].value.toString().substr(-8) : '',
    fax2: isMobile ? '09' : '',
    mobilePhone1Country: isMobile ? market.toUpperCase() : '',
    phone1: isMobile ? '' : state['phone'].value.toString().substr(-7),
    fax1: isMobile ? '' : state['phone'].value.toString().substr(0, 2),
  };
};

export const returnProvidenceIdCl = (address, regions) => {
  const stateFiltered = filterState(address, regions);
  if (!stateFiltered.length) return '';
  const cityFiltered = stateFiltered[0].children.filter(function (city) {
    return city.id.toString() === address.city;
  });
  if (!cityFiltered.length) return '';
  return cityFiltered[0].id.toString();
};
